import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { SingleSkeletonLoader } from '../components/SingleSkeletonLoader';
import { usePerMonthPriceForTerm } from '../hooks/pricing/useGrowthPurchaseOptions';
import { useQueryParamTerm } from '../utils/urls/appQueryParamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceByProductApiName = ({
  productApiName,
  showPerMonthPerSeat = false
}) => {
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const {
    price,
    currencyCode,
    loading,
    error
  } = usePerMonthPriceForTerm({
    productApiName,
    term: queryParamTerm
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40,
      width: 175
    });
  }
  if (error || !price) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      inlineSize: "175px"
    });
  }
  if (showPerMonthPerSeat) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceComponents.pricePerMonthPerSeat",
      options: {
        price: /*#__PURE__*/_jsx(PriceDisplay, {
          price: price,
          currencyCode: currencyCode,
          dataSelenium: `${productApiName}-price-per-month`
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "priceComponents.pricePerMonth",
    options: {
      price: /*#__PURE__*/_jsx(PriceDisplay, {
        price: price,
        currencyCode: currencyCode,
        dataSelenium: `${productApiName}-price-per-month`
      })
    }
  });
};